export default {
  "content": "<g clip-path=\"url(#clip0_429_7181)\" stroke=\"#C33232\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M8 14.982A6.667 6.667 0 108 1.649a6.667 6.667 0 000 13.333zM3.287 3.602l9.426 9.426\"/></g><defs><clipPath id=\"clip0_429_7181\"><path fill=\"#fff\" transform=\"translate(0 .314)\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "16",
    "height": "17",
    "viewBox": "0 0 16 17",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};